var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('o-view',[_c('o-nav-bar',{attrs:{"title":"Ticket","has-back-button":true}}),_c('o-section',[_c('p',[_vm._v("Ticket in KBC app")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }